<template>
	<v-container fluid>
		<div v-if="!loading">
			<div v-if="trademarkAwareness">
				<v-row class="total secondary--text">
					Brand awareness assessment
				</v-row>
				<!--table head-->
				<v-row class="total mt-8" no-gutters>
					<v-col class="tabCell text-left">Trademark</v-col>
					<v-col v-for="item in headers"
						class="tabCell"
						:key="item">{{item}}
					</v-col>
				</v-row>
				<!--table content-->
				<v-row v-for="item in matchTrademarks" :key="item.brandId" no-gutters>
					<v-col class="tabCell text-left">{{item.name}}</v-col>
					<v-col class="tabCell">{{format(brandAwareness(item.name))}}</v-col>
					<v-col class="tabCell">{{pricePerception(item.name)}}</v-col>
					<v-col class="tabCell">{{corePerception(item.name)}}</v-col>
					<v-col class="tabCell">{{advancedPerception(item.name)}}</v-col>
					<v-col class="tabCell">{{bestProduct(item.name)}}</v-col>
				</v-row>
				<v-row class="total secondary--text mt-4">
					Brand loyalty
				</v-row>
				<!--table head-->
				<v-row class="total mt-4" no-gutters>
					<v-col class="tabCell text-left">Trademark</v-col>
					<v-col v-for="(item, index) in brandLoyalty" :key="index"
						class="tabCell">{{item.segment}}
					</v-col>
				</v-row>
				<!--table content-->
				<v-row v-for="(item, index) in matchTrademarks" :key="index" no-gutters>
					<v-col class="tabCell text-left">{{item.name}}</v-col>
					<v-col v-for="seg in brandLoyalty"
						:key="seg.id" class="tabCell">
							{{format(awareness(item.name, seg))}}
					</v-col>
				</v-row>
			</div>
			<div v-else>
				<v-row class="total" justify="center">
					Select the round & press the button "load", please
				</v-row>
			</div>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import numeral from 'numeral'
	import Loader from '../../../layouts/Loader.vue'
	
	export default {
		props: ['round', 'gameId'],
		data () {
			return {
				headers: ['Brand awareness','Price perception','Core feature perception', 'Advanced feature perception', 'Best product for']
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			trademarks () {
				return this.$store.getters.trademarks
			},
			matchTrademarks () {//match only last year trademarks => which are in trademarkAwareness
				const res = []
				this.trademarks.forEach(tr => {
					const inTrAwareness = this.trademarkAwareness.find(item => item.trademark === tr.name)
					if (inTrAwareness) {
						res.push(tr)
					}
				})
				return res
			},
			//from summary last round
			trademarkAwareness () {
				return this.$store.getters.trademarkAwareness
			},
			brandLoyalty () {
				return this.$store.getters.brandLoyalty
			},
			awarenessPrevious () {
				return this.$store.getters.awarenessPrevious
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('% 0[.]0')//
			},
			//=> trademarkAwareness object
			brandAwareness (tr) {
				const summObj = this.trademarkAwareness.find(item => item.trademark == tr)
				if (summObj) return (summObj.brandAwareness)
				else return 0
			},
			pricePerception (tr) {
				const summObj = this.trademarkAwareness.find(item => item.trademark == tr)
				if (summObj) return (summObj.pricePerception)
				else return 0
			},
			corePerception (tr) {
				const summObj = this.trademarkAwareness.find(item => item.trademark == tr)
				if (summObj) return (summObj.corePerception)
				else return 0
			},
			advancedPerception (tr) {
				const summObj = this.trademarkAwareness.find(item => item.trademark == tr)
				if (summObj) return (summObj.advancedPerception)
				else return 0
			},
			bestProduct (tr) {
				const summObj = this.trademarkAwareness.find(item => item.trademark == tr)
				if (summObj) return (summObj.bestProduct)
				else return 0
			},
			awareness (trademark, segment) {
				return segment.brandLoyalty[trademark]
			},
			currentAwareness (trademark) {
				if (this.awarenessPrevious) return this.awarenessPrevious[trademark]
				else return 0
			}
		},
		components: {Loader}
	}
</script>